module.exports = __webpack_public_path__ + "img/c_photo_4.52898a5d.png";